import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../../assets/images/bet-frenzy/Betfrenzy Logo Transparent.png";
import Credit from "../../assets/images/svgs/credit-card 1.png";
import Age from "../../assets/images/svgs/age 1.png";
import Dis from "../../assets/images/svgs/discord.png";
import Twitter from "../../assets/images/svgs/twitter (2).png";
import { getCms } from "../../redux/slices/auth/cmsSlice";

const Footer = () => {
  const navigate = useNavigate();
  const configData = useSelector((state) => state.config.data);
  const isMobile = window.innerWidth <= 992;
  const dispatch = useDispatch();
  const { data: cmsData } = useSelector((state) => state.getCms);
  const { data: profileData } = useSelector((state) => state.getProfile);


  console.log(cmsData)

  useEffect(() => {
    dispatch(
      getCms({ domain: "betfrenzy", user_id: profileData?.user?._id || "" })
    );
  }, [profileData]);

  return (
    <>
      <footer
        className={`footer container px-4 ${
          !isMobile ? "middle-container" : ""
        }`}
      >
        <div className="d-flex flex-wrap text-center justify-content-center my-2 my-sm-2 my-md-4 my-lg-4 my-xl-4 align-items-center gap-2">
          <div className="d-flex me-md-auto">
            <div className="d-flex">
              <img
                draggable="false"
                loading="lazy"
                src={Age}
                className="m-1"
                alt=""
              />
              <img
                draggable="false"
                loading="lazy"
                src={Credit}
                className="m-1"
                alt=""
              />
            </div>
          </div>
          {window.innerWidth > 1024 ? (
            <span
              className="fs-10 text-start"
              style={{
                width: `${
                  (document.querySelector(".footer")?.clientWidth - 300) / 10
                }%`,
              }}
            >
              Attention! It is gambling advertising. Gambling is not suitable
              for solving financial problems. Please read terms and conditions
              and play responsibly.
            </span>
          ) : (
            <span className="mx-3 ">
              Attention! It is gambling advertising. Gambling is not suitable
              for solving financial problems. Please read terms and conditions
              and play responsibly.
            </span>
          )}
        </div>
        <hr />

        <div className="footer-top">
          <div className="footer-links-section">
            <div
              className={`fs-12 footer-sub-section ${
                window.innerWidth > 1024 ? "text-start" : "text-start"
              }`}
            >
              <h4 className="color-767e99 fs-12">Our Products</h4>
              <ul className="" style={{ fontSize: ".8125rem" }}>
                <li>Sports Betting</li>
                <li>Virtual Sports</li>
                <li>ESports</li>
                <li>Casino</li>
                <li>Live Casino</li>
                <li>Mini Games</li>
                <li>Racing</li>
              </ul>
            </div>

            <div
              className={`fs-12 footer-sub-section ${
                window.innerWidth > 1024 ? "text-start" : "text-start"
              }`}
            >
              <h4 className="color-767e99 fs-12">Information</h4>
              <ul className="" style={{ fontSize: ".8125rem" }}>
                <li>Company Details</li>
                <li>Terms & Conditions</li>
                <li>Responsible Gaming</li>
                <li>Privacy Policy</li>
                <li>Sportsbook Terms</li>
                <li>Promotions</li>
              </ul>
            </div>
            <div
              className={`fs-12 footer-sub-section ${
                window.innerWidth > 1024 ? "text-start" : "text-start"
              }`}
            >
              <h4 className="color-767e99 fs-12">Help</h4>
              <ul className="" style={{ fontSize: ".8125rem" }}>
                {cmsData?.data?.map((item) => (
                  <li key={item._id}>
                    <Link
                      to={`/cms/${item.code
                        .toLowerCase()
                        .replace(/[^a-z0-9]+/g, "-")
                        .replace(/(^-|-$)/g, "")}`}
                      className="text-decoration-none"
                      style={{ color: "#ccd6f6" }}
                    >
                      {item.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div
              className={`fs-12 footer-sub-section ${
                window.innerWidth > 1024 ? "text-start" : "text-start"
              }`}
            >
              <h4 className="color-767e99 fs-12">Contact Us</h4>
              <ul className="" style={{ fontSize: ".8125rem" }}>
                <li> Live Chat 24/7</li>
                <li>support@betfrenzy.com</li>
                <li>affiliate@betfrenzy.com</li>
                <li>vip@betfrenzy.com</li>
                <li>payments@betfrenzy.com</li>
                <li>kyc@betfrenzy.com</li>
              </ul>
            </div>
          </div>
        </div>
        <div
          className="d-flex social-icons justify-content-end"
          style={{ marginRight: isMobile ? "212px" : "100px" }}
        >
          <img
            draggable="false"
            loading="lazy"
            alt="img"
            src={Dis}
            className="m-1"
          />
          <img
            draggable="false"
            loading="lazy"
            alt="img"
            src={Twitter}
            className="m-1"
          />
        </div>
        <div className="d-flex justify-content-between align-items-center mt-3">
          <div className="text-start">
            <p className="fs-11 text-center">
              BetsFrenzy.com is operated by BetsFrenzy B.V., a company
              incorporated under the laws of Curaçao with Company Number 162345.
              The company is licensed and regulated by the Curaçao Gaming
              Control Board to offer games of chance under license number
              OGL/2025/1920/1177, in accordance with the National Ordinance on
              Offshore Games of Hazard (Landsverordening buitengaatse
              hazardspelen, P.B. 1993, no. 63) (NOOGH). Let me know if you'd
              like to customize this further for your website’s footer, terms
              and conditions, or regulatory page.
            </p>
          </div>
        </div>
        <div className="text-center m-auto my-3">
          <img
            src={configData?.website_logo ? configData?.website_logo : Logo}
            alt=""
            className="cursor-pointer footer-logo"
            onClick={() => {
              navigate("/");
            }}
            style={{ maxHeight: "90px", width: "auto" }}
          />
        </div>
        {/* <hr /> */}
      </footer>
    </>
  );
};

export default Footer;
